<template>
    <div class="modal_footer md:left-auto" :class="[variant, position]" ref="modalFooter">
        <slot></slot>
        <AppButton
            type="button"
            variant="blue"
            :btnText="cancelBtnText"
            outline
            block
            :iconType="iconType"
            :icon="cancelIcon"
            @buttonClick="onCloseFooter"
            :isLoading="btnLoading === 'cancel'"
            v-if="showCancelButton"
        />
        <template v-if="isFormkit">
            <slot name="formkitButton"></slot>
        </template>
        <template v-else>
            <AppButton
                v-if="showSaveButton"
                type="button"
                variant="blue"
                :btnText="saveBtnText"
                block
                :form="formId"
                :iconType="iconType"
                :icon="saveIcon"
                @buttonClick="$emit('onSubmit')"
                :disabled="btnDisabled === 'save'"
                :isLoading="btnLoading === 'save'"
            />
            <!-- {{ saveBtnText }} -->
        </template>
        <input type="submit" class="hidden" />
    </div>
</template>

<script setup>
import AppButton from "@/components/appComponents/AppButton.vue";
import useToggleModal from "@/composables/useToggleModal";
import { useHeaderStore } from "@/stores/headerStore.js";

const headerStore = useHeaderStore();
const props = defineProps({
    types: {
        type: String,
        default: "submit",
    },
    formId: {
        type: String,
        default: "",
    },
    variant: {
        type: String,
        default: "",
    },
    cancelBtnText: {
        type: String,
        default: "Cancel",
    },
    showCancelButton: {
        type: Boolean,
        default: true,
    },
    showSaveButton: {
        type: Boolean,
        default: true,
    },
    saveBtnText: {
        type: String,
        default: "Save",
    },
    isFormkit: {
        type: Boolean,
        default: false,
    },
    position: {
        type: String,
        default: "",
    },
    iconType: {
        type: String,
        default: "",
    },
    cancelIcon: {
        type: String,
        default: "",
    },
    saveIcon: {
        type: String,
        default: "",
    },
    from: {
        type: String,
        default: "",
    },
    btnLoading: {
        type: String,
        default: "",
    },
    btnDisabled: {
        type: String,
        default: "",
    },
});

const emit = defineEmits(["onSubmit", "onHideModal"]);

const { toggleModal } = useToggleModal();
const onFooterToggle = () => {
    emit("onHideModal");
    // props.directClose ? toggleModal() : false;
};
const onCloseFooter = () => {
    onFooterToggle();
    headerStore.setBoardFormName("");
};
</script>

<style scoped>
.modal_footer {
    @apply flex items-center sm:justify-end justify-center text-center sm:px-6 px-4 sm:py-6 py-4 sticky bg-white dark:!bg-black-500 z-20 left-0 right-0 sm:static md:left-auto md:ltr:right-0 md:rtl:left-0 bottom-0;
    /* @apply flex items-center md:justify-end justify-center md:py-6 py-2 px-6 md:-mb-4 md:mt-6 */
}
.modal_footer.secondary {
    @apply sm:gap-6 gap-4 bg-white w-full;
    /* @apply flex items-center md:justify-end justify-center md:py-6 py-2 px-6 md:-mb-4 md:mt-6 */
}
.modal_footer.secondary .vz_btn {
    @apply flex-1 rounded xs:rounded-full;
}
.modal_footer.secondary :deep(.formkit-outer[data-family="button"]) {
    @apply flex-1;
}
.modal_footer.secondary :deep(.formkit-outer[data-family="button"] .formkit-wrapper) {
    @apply mb-0;
}
.modal_footer.secondary :deep(.formkit-outer[data-family="button"]) .formkit-input {
    @apply rounded w-full dark:text-black-900 font-medium xs:rounded-full;
}
.modal_footer button {
    /* @apply ltr:ml-2 rtl:mr-2; */
}
.modal_footer.secondary button {
    /* @apply ltr:ml-0 rtl:mr-0; */
}

.modal_small .modal_footer {
    @apply justify-center static;
}
</style>
